import { useState } from "react";
import { animated, useSpring } from "react-spring";
import { bioPink } from "../../../constants/constants";
import { useWindowSize } from "../../../hooks/useWindowSize";

export const PageNumber = ({
  gridArea,
  pageNumber = "01",
}: {
  gridArea: string;
  pageNumber?: string;
}) => {
  const [marginLeftAnimated, setMarginLeftAnimated] = useState(false);
  const [widthAnimated, setWidthAnimated] = useState(false);
  const { marginLeft } = useSpring({
    from: { marginLeft: "24px" },
    to: { marginLeft: "0px" },
    onRest: () => setMarginLeftAnimated(true),
  });
  const { height } = useSpring({
    from: { height: "0px" },
    to: { height: marginLeftAnimated ? "36px" : "0px" },
  });
  const { width } = useSpring({
    from: { width: "0px" },
    to: { width: "20px" },
    onRest: () => setWidthAnimated(true),
  });
  const { transform } = useSpring({
    from: { transform: "rotate(0deg)" },
    to: { transform: widthAnimated ? "rotate(25deg)" : "rotate(0deg)" },
  });
  const { mobileVertical, tabletVertical, horizontal }: any = {
    ...useWindowSize(),
  };
  return (
    <div
      style={{
        gridArea,
        placeSelf: horizontal ? "center end" : "center start",
        fontWeight: 500,
        fontSize: 16,
        letterSpacing: 1,
        flex: mobileVertical || tabletVertical ? "" : 1,
        marginTop: mobileVertical || tabletVertical ? "2vh" : "0",
        height: "36px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-start",
        zIndex: 99,
      }}
    >
      <div
        style={{
          overflow: "hidden",
          width: "2rem",
        }}
      >
        {/* animate height */}
        <animated.div
          style={{
            height,
            overflow: "hidden",
            fontSize: "1.5rem",
            lineHeight: "2rem",
          }}
        >
          {pageNumber}
        </animated.div>
        {/* animate x position */}
        <animated.div
          style={{
            marginLeft,
            height: "0.13em",
            backgroundColor: "#ffffff",
            width: "2rem",
          }}
        />
      </div>
      <div
        style={{
          color: bioPink,
          display: "flex",
          marginLeft: "0.75rem",
          fontSize: "0.75rem",
          lineHeight: "1rem",
          alignItems: "center",
        }}
      >
        <animated.div
          style={{
            backgroundColor: bioPink,
            width: "2px",
            height: "10px",
            transform,
          }}
        ></animated.div>
        <animated.div
          style={{ width, overflow: "hidden", marginLeft: "0.25rem" }}
        >
          05
        </animated.div>
      </div>
    </div>
  );
};
